// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UserMessageFormWrap_wrap__27eu0","avatar":"UserMessageFormWrap_avatar__8Ez4b","body":"UserMessageFormWrap_body__2dgJD"};